import {
    EmailSubsectionChip, IconClockTable,
    IconScheduleTable, MobileIcon,
} from "../../../../../components/buttons/IconButtons";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    downloadActionFile,
    EMPTY_VALUES,
    getDateFormat
} from "../../../../../Apis/functions";

import CustomTooltip from "../../../../../components/CustomTooltip";
import {useTranslation} from "react-i18next";
import CustomFileCard from "../../../../../components/CustomFileCard";
import React from "react";
import {FILE_MODEL} from "../../../../Dashboard/Visitor/Visitor/Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const OrderReceiverDetail = ({ getOrderDetails }) => {
    const { t } = useTranslation();
    const assets = getOrderDetails?.evidence?.map(e => FILE_MODEL.set(e));
    const receivers = getOrderDetails?.receivers;

    return (
        <>
            <div className='col-12 px-0'>
                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 mt-3'>
                    {t('received_by')}
                </p>
                {receivers?.length > 0 ?
                    <>
                        { receivers.map((u, index) => {
                                return <div className={`${index < receivers.length -1 ? 'mb-2' :''}`}>
                                    <div className={'flex-grow-1 minw-0'}>
                                        <CustomTooltip
                                            text={u.name}
                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row px-0`}
                                            showIfTruncated={true}
                                        />
                                    </div>
                                    <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                        <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                                            <div className={'mr-2 d-flex align-items-center'}>
                                                <EmailSubsectionChip />
                                            </div>
                                            <div className={'flex-grow-1 minw-0'}>
                                                <CustomTooltip
                                                    text={u.email}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        <div className={'d-flex flex-grow-1 minw-0'}>
                                            <div className={'mr-2 mb-1 d-flex align-items-center'}>
                                                <MobileIcon className='icon-color-shades-800 flex-shrink-0' />
                                            </div>
                                            <div className={'flex-grow-1 minw-0'}>
                                                <CustomTooltip
                                                    text={u.phoneNumber}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </>
                    :
                    EMPTY_VALUES.DEFAULT
                }
            </div>

            <div className='border-bottom-shades-300 mt-3'/>

            <div className='col-12 px-0'>
                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 mt-3'>
                    {t('delivery_date')}
                </p>

                <div className={'d-flex justify-content-between p-0 gap-3 '}>
                    <div className={'d-flex flex-grow-1 minw-0'}>
                        <div className={'mr-2 mb-1 d-flex align-items-center'}>
                            <IconScheduleTable className='icon-color-shades-800 flex-shrink-0' />
                        </div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={getDateFormat(getOrderDetails?.actualDeliveryDate,false, DATE_TIME_FORMAT_NAME_MODEL.dayWithShortMonth)}
                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                showIfTruncated={true}
                            />
                        </div>
                    </div>
                    <div className={'d-flex flex-grow-1 minw-0'}>
                        <div className={'mr-2 mb-1 d-flex align-items-center'}>
                            <IconClockTable className='icon-color-shades-800 flex-shrink-0' />
                        </div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={getDateFormat(getOrderDetails?.actualDeliveryDate,false,DATE_TIME_FORMAT_NAME_MODEL.time12Uppercase)}
                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                showIfTruncated={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='border-bottom-shades-300 mt-3'/>

            <div className='col-12 px-0 gap-2 mt-3'>
                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                    {t('note')}
                </p>
                <p className='font-color-general-950 fs-14px px-0'>
                    {getOrderDetails?.deliveryNote || EMPTY_VALUES.DEFAULT}
                </p>
            </div>

            <div className='col-12 px-0 gap-2 mt-3'>
                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                    {t('evidence')}
                </p>
                {assets?.length > 0 ?
                    assets?.map((e) => {
                        return (
                            <div className={'mt-2'}>
                                <CustomFileCard
                                    Icon={e.Icon}
                                    title={e.name}
                                    subtitle={
                                        <p className={'justify-content-start d-flex ibl-font-w-400 fs-10px'}>
                                            {e.size}
                                        </p>
                                    }
                                    fileValue={e.filePath}
                                    buttonId={'btn_ord_download_' + e.id}
                                    onClick={() => downloadActionFile(e.filePath)}
                                />
                            </div>
                        );
                    })
                    : EMPTY_VALUES.DEFAULT
                }
            </div>
        </>
    );
};

export default OrderReceiverDetail;
